import { Badge, Flex } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { AutoColorBadge } from '~/components/shared/AutoColorBadge'
import { RegionSelector } from '~/components/shared/RegionSelector'
import { useColorMode } from '~/components/ui/color-mode'
import { useAppVersion } from '~/hooks/useAppVersion'
import { ClockSkewNotice } from '~/pages/Login/ClockSkewNotice'
import UpdaterButton from '~/pages/Settings/UpdaterButton'
import { isElectron } from '~/utils/common'

import './Login.styles.css'

const StaticBackground = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      height="100vh"
      width="100%"
      position="absolute"
      display="flex"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
    >
      {children}
    </Flex>
  )
}

export const LoginBackground = ({
  children,
  showUpdaterButton = true,
}: {
  children: React.ReactNode
  showUpdaterButton?: boolean
}) => {
  const [selectedModeIndex, setSelectedModeIndex] = React.useState(0)
  useEffect(() => {
    setSelectedModeIndex(Math.floor(Math.random() * gradients.length))
  }, [])
  const { colorMode } = useColorMode()
  const gradients = [
    'login-gradient-2tone-bottomRight',
    'login-gradient-2tone-bottomLeft',
    'login-gradient-2tone-top',
  ]
  const appVersion = useAppVersion()
  const [channel, setChannel] = useState<string | null>(null)

  useEffect(() => {
    if (!isElectron) return
    void window.electron?.channels.getBuildEnv().then((ch) => {
      setChannel(ch ?? null)
    })
  }, [])

  const showChannelBadge = channel && channel !== 'prod' && channel !== 'dev'

  const selectedMode = gradients[selectedModeIndex]
  const gradientClass = `${selectedMode}-${colorMode}`
  return (
    <StaticBackground>
      <div className={`login-gradient-container ${gradientClass}`} />
      <ClockSkewNotice />
      <Flex
        position="absolute"
        bottom="1rem"
        right="1rem"
        alignItems="center"
        gap={2}
      >
        <Badge
          variant={'subtle'}
          paddingX={'.5rem'}
          paddingY={'.25rem'}
          borderRadius={'.25rem'}
          fontSize={'xs'}
          minH={'auto'}
          backgroundColor={'var(--chakra-colors-brand)'}
          textTransform={'lowercase'}
        >
          v{appVersion}
        </Badge>
        {showChannelBadge && (
          <AutoColorBadge
            label={channel}
            colorKey={channel}
            theme={colorMode}
            fontSize="xs"
            textTransform="lowercase"
          />
        )}
      </Flex>
      <Flex
        position="absolute"
        top="1rem"
        right="1rem"
        gap={2}
        alignItems="center"
      >
        {showUpdaterButton && (
          <UpdaterButton variant="icon" clearMessageDelayMs={2000} />
        )}
        <RegionSelector />
      </Flex>
      {children}
    </StaticBackground>
  )
}
